export const CECI_BETA = 'CECI-BETA';
export const CECI_FREE = 'CECI-FREE';
export const CECI_LITE = 'CECI-LITE';

export const CECI_LITE_PROJECTS_LIMIT = '4';